import { Link } from 'react-router-dom'
import { BlurFade } from '@/components/ui/blur-fade'
import { ShineBorder } from '@/components/ui/shine-border'
import { PillButton } from './PillButton'

const SERVICES = [
  'Daily reset sessions for teams',
  'Founder & leadership wellbeing programs',
  'Corporate offsites and retreats',
  'Thematic workshops on stress, resilience, and clarity',
]

export function ForOrganizationsSection() {
  return (
    <section className="bg-cream">
      <div className="mx-auto max-w-[880px] px-6 py-16 lg:py-20">
        <BlurFade>
          <h2 className="text-center text-3xl font-bold text-gray-900 sm:text-4xl">
            For teams, founders, and organizations
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-gray-700">
            High-performing people need more than productivity tools. They need
            nervous system regulation, emotional resilience, recovery, clarity,
            and connection.
          </p>
        </BlurFade>

        {/* Flagship ENERGIZERS card */}
        <BlurFade delay={0.1}>
          <div className="relative mt-10 overflow-hidden rounded-3xl bg-primary-900 p-8 text-cream shadow-xl sm:p-10">
            <ShineBorder borderWidth={1.5} shineColor={['#6b926c', '#a5c3a5']} />
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-200">
              Flagship program
            </p>
            <h3 className="mt-3 text-2xl font-bold sm:text-3xl">
              ENERGIZERS — A Leadership Performance Lab
            </h3>
            <p className="mt-4 max-w-xl leading-relaxed text-primary-100">
              Cohort-based wellness for founders and leaders. Breathwork ·
              Movement · Emotional agility · Stillness.
            </p>
            <Link
              to="/energizers-june-cohort-signup"
              className="mt-6 inline-flex items-center gap-1 rounded-full bg-cream px-6 py-2.5 text-sm font-semibold text-primary-900 transition-colors hover:bg-cream-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2 focus-visible:ring-offset-primary-900"
            >
              See current cohort →
            </Link>
          </div>
        </BlurFade>

        <BlurFade delay={0.15}>
          <div className="mt-10">
            <p className="text-gray-700">We also design:</p>
            <ul className="mt-4 space-y-2">
              {SERVICES.map((service) => (
                <li
                  key={service}
                  className="flex items-start gap-2 text-gray-800"
                >
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-500" />
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </BlurFade>

        <BlurFade delay={0.2}>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <PillButton to="/corporates" variant="primary">
              Explore workplace wellness
            </PillButton>
            <PillButton to="/corporates" variant="secondary">
              Design a program with us
            </PillButton>
          </div>
        </BlurFade>
      </div>
    </section>
  )
}
